import { useState } from "react";
import { useSimpleRequest, type RequestSettings } from "hooks";
import { sendDecision } from "features/onboarding/api";
import type { WithUser } from "./types";

export const useSendApplicationDecision = (requestSettings: RequestSettings = {}) => {
    const [isLoading, setLoading] = useState(false);

    const request = useSimpleRequest({
        shouldNotifyOnSuccess: true,
        ...requestSettings,
        setLoading
    });

    const sendApplicationDecision = ({ userId }: WithUser) =>
        request(() => sendDecision({
            userId
        }));

    return {
        isLoading,
        sendApplicationDecision
    };
};

export default useSendApplicationDecision;
